/** @jsxImportSource react */
import { FunctionComponent } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { recaptchaSiteKey } from '@/lib/globals';

export const RecaptchaProvider: FunctionComponent = ({ children }) => (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey} useRecaptchaNet={true} useEnterprise={true}>
        {children}
    </GoogleReCaptchaProvider>
);
